<template>
  <div class="ui-container">
    <h2>Stepper</h2>
    <div class="ui-block">
      <Stepper
        :steps="['About you', 'About your company', 'Go!']"
        :currentStep="1"
      />
      <Stepper
        :steps="['About you', 'About your company', 'Go!']"
        :currentStep="2"
      />
      <Stepper
        :steps="['About you', 'About your company', 'Go!']"
        :currentStep="3"
      />
    </div>
  </div>
</template>
